import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';
import RegularShape from 'ol/style/RegularShape';
import LineString from 'ol/geom/LineString';

const dragBox = () => {
	return new Style({
		stroke: new Stroke({
			color: [ 48, 154, 228, 1 ]
		}),
		fill: new Fill({
			color: [ 48, 154, 228, 0.1 ]
		}),
		image: new Circle({
			radius: 7,
			fill: new Fill({
				color : [ 48, 154, 228, .8 ]
			})
		})
	});
}

const vector = () => {
	return new Style({
		stroke: new Stroke({
			color: '#CCCCCC',
			width: 1			
		}),
		fill: new Fill({
			color: 'rgba(00, 255, 00, 0.2)'
		}),
		image: new Circle({
			radius: 7,
			fill: new Fill({
				color: 'rgba(00, 255, 00, 0.2)'
			})
		})
	});
}

const draw = () => {
	const polygonStyle = new Style({
		fill: new Fill({
	    	color: 'rgba(14, 238, 35, 0.5)'
	    }),
	    stroke: new Stroke({
	    	color: 'rgba(45, 154, 228, 0.5)',
	            width: 4
	        }),
	        image : new Circle({
	            radius: 7,
	            fill: new Fill({
	                color: 'rgba(00, 255, 00, 0.5)'
	            })
	        })
	    });
        
    const lineStyle = new Style({
		stroke: new Stroke({
        	color: 'rgba(45, 154, 228, 0.5)',
            	width : 8
            })
        });
         
    const pointStyle = new Style({
    	fill: new Fill({
            color: 'rgba(00, 255, 00, 0.5)'
        }),
        stroke: new Stroke({
            color : '#CCCCCC',
            width : 2
        }),
        image: new Circle({
        	radius : 7,
         	fill : new Fill({
            	color : 'rgba(255, 00, 00, 0.5)'
         	})
       	})
    });
        
    return (feature, resolution) => {    
        if( feature ) {
            const type = feature.getGeometry().getType();
            if( type === 'MultiPolygon' || type === 'Polygon' ) {
               return [polygonStyle];
            } else if( type === 'MultiLineString' || type === 'LineString' ) {
                return [lineStyle];
            } else {
                return [pointStyle];
            }
        } else {
            return [];
        }
	};
}


const measure = () => {
	const lineStyle = new Style({
        stroke: new Stroke({
            color: 'rgba(45, 154, 228, 0.5)',
            width: 4
        })
    });
     
    const pointStyle = new Style({
        fill: new Fill({
            color: 'rgba(00, 255, 00, 0.5)'
        }),
        stroke : new Stroke({
            color: '#CCCCCC',
            width: 2
        }),
        image: new Circle({
            radius: 7,
            fill: new Fill({
                color: 'rgba(255, 00, 00, 0.5)'
            })
        })
    });
    
    return (feature, resolution) => {    
        if( feature ) {
            const type = feature.getGeometry().getType();
            if( type === 'MultiLineString' || type === 'LineString' ) {
                return [lineStyle];
            } else {
                return [pointStyle];
            }
        } else {
            return [];
        }
    };
}

const featureHighlight = () => {
	const polygonStyle = new Style({
        fill: new Fill({
            color : 'rgba(255, 0, 0, 0.2)'
        }),
        stroke: new Stroke({
            color : '#AAAAAA',
            width : 4,
            lineDash: [10,20]
        })
    });
    
	const lineStyle = new Style({
        stroke: new Stroke({
            color: 'rgba(255, 0, 0, 0.2)',
            width: 8
        })
    });
     
    const pointStyle = new Style({
        image: new Circle({
        	radius : 7,
         	stroke : new Stroke({
            	color : 'rgba(50, 50, 50, 0.90)'
         	}),
         	fill: new Fill({
				color : 'rgba(235, 235, 235, 0.25)'
        	}),
       	})
    });
    
    return (feature, resolution) => {    
        if( feature ) {
            const type = feature.getGeometry().getType();
			
			if( type === 'MultiPolygon' || type === 'Polygon'  || type === 'GeometryCollection') {
               return [polygonStyle];
            } else if( type === 'MultiLineString' || type === 'LineString' ) {
                return [lineStyle];
            } else  {
                return [pointStyle];
            }  
        } else {
            return [];
        }
    };
}


const pointHighlight = () => {
	const stroke = new Stroke({
        color: 'rgba(50, 50, 50, 0.90)'
    });
    
    const fill = new Fill({
        color: 'rgba(235, 235, 235, 0.25)'
    });

	const polygonStyle = new Style({
        fill: fill,
        stroke: stroke
    });
         
    const pointStyle = new Style({
        image: new Circle({
        	radius: 7,
         	stroke: stroke,
         	fill: fill,
       	})
    });
    
    return (feature, resolution) => {    
        if( feature ) {
            const type = feature.getGeometry().getType();
			
			if( type === 'MultiPolygon' || type === 'Polygon'  || type === 'GeometryCollection') {
               return [polygonStyle];
            } else  {
                return [pointStyle];
            }  
        } else {
            return [];
        }
    };
}

const calculateSource = () => new Style({
        fill: new Fill({
            color: 'rgba(255, 0, 0, 0.8)'
        }),
        stroke: new Stroke({
            color: '#AAAAAA',
            width: 2
        }),
        image: new Circle({
            radius: 12,
            fill: new Fill({
                color: 'rgba(255, 00, 00, 0.8)'
            })
        })
    });


const locate = () => new Style({
			            stroke: new Stroke({
			                color: 'rgba(255, 0, 0, 0.8)',
			                width: 2,
			                lineDash: [5,10]
			            })
			        });
			        
const getCrossHairStyle = (color) => {
	const stroke = new Stroke({
		color: color,
	    width: 1
	});
	    
    return [
    	new Style({	        
	        image: new Circle({
	            radius: 8,
	            stroke: stroke,
	        })
    	}),
    	new Style({	        
	        image: new RegularShape({
  				stroke: stroke,
  				points: 4,
  				radius: 12,
  				radius2: 0,
  				angle: 0
			})
    	})
    ];
}

const getGeolocationUnavailableStyle = (color) => {
	const stroke = new Stroke({
		color: color,
	    width: 1
	});
    
    return [
    	new Style({	        
	        image: new Circle({
	            radius: 8,
	            stroke: stroke,
	        })
    	}),
    	new Style({	        
	        image: new RegularShape({
  				stroke: stroke,
    			points: 4,
    			radius: 8,
    			radius2: 0,
    			angle: 4
			})
    	})
	];
}

const crossHair = () => getCrossHairStyle("#da1313");
const geolocationUnavailable = () => getGeolocationUnavailableStyle("#da1313");	

const dashed = () => new Style({
            stroke : new Stroke({
                color: '#000',
                lineDash: [2, 5],
                width: 2
            })
        });
        
const arrow = () => {
	const stroke = new Stroke({
        color : 'rgba(255, 0, 0, 0.8)',
        width : 2
    });
        
	const style = (feature, resolution) => {
        const geometry = feature.getGeometry();
        const styles = [
            new Style({                   
                stroke : stroke
            })        
        ];
        
        geometry.forEachSegment( (start, end) => {
            var dx = end[0] - start[0];
            var dy = end[1] - start[1];
            var rotation = Math.atan2(dy, dx);
            var length = resolution * 10;

            const lineStr1 = new LineString([end, [end[0] - length, end[1] + length]]);
            lineStr1.rotate(rotation, end);
            
            const lineStr2 = new LineString([end, [end[0] - length, end[1] - length]]);
            lineStr2.rotate(rotation, end);
    
            styles.push(new Style({
                geometry: lineStr1,
                stroke: stroke
            }));
            
            styles.push(new Style({
                geometry: lineStr2,
                stroke: stroke
            }));
        });

        return styles;          
    }
    
    return style;
}

const style_types = {
	dragBox, vector,
	draw, measure, 
	featureHighlight, pointHighlight,
	calculateSource,
	locate,
	crossHair,
	getCrossHairStyle,
	geolocationUnavailable,
	dashed,
	arrow	
}

export {
	style_types
}